import { Tag } from 'antd';
import { TAG_COLORS } from '@gtintel/platform-constants';
import styles from './partnerTag.module.scss';
const PartnerTag = props => {
  const {
    tags
  } = props;
  return <div className={styles.container}>
      <div className={styles.labelSection}>
        <div className={styles.label}>Tags</div>
        <div className={styles.icon}>
          <div>
            <img src={`/assets/icons/info-blue.svg`} alt="" />
          </div>
        </div>
      </div>
      <div className={styles.tagSection}>
        {Array.isArray(tags) && tags.map((tag, index) => <Tag key={index} color={TAG_COLORS[tag.tag_group_code ?? tag.tag_group]} className={styles.tagItem}>
              {tag.name}
            </Tag>)}
      </div>
    </div>;
};
export default PartnerTag;